/**
 * Настройки тепловой карты стакана.
 */

import type { OrderFlowVenue } from '@specter/types';
import type { IndicatorParams } from '../indicators/types.js';

export interface BookHeatmapSettings {
  readonly venues: ReadonlySet<OrderFlowVenue>;
  /** Насколько ярко горят клетки, 0…1. */
  readonly intensity: number;
  /** Клетки слабее этой доли от самых плотных не рисуются. */
  readonly floor: number;
  readonly ladder: boolean;
  /** Показывать ли крупные заявки линией, пока они стоят. */
  readonly walls: boolean;
  /** Во сколько раз плотнее обычного уровня считать стеной. */
  readonly wallFactor: number;
  /** Сколько минут заявка должна простоять, чтобы её отметить. */
  readonly wallMinutes: number;
  /** Дополнительный порог в долларах; 0 — только относительный. */
  readonly wallMinUsd: number;
  /** Сколько линий показывать: остаются самые крупные. */
  readonly wallLimit: number;
  readonly ladderWidth: number;
  readonly colors: { readonly bid: string; readonly ask: string };
}

function value<T>(p: IndicatorParams, key: string, fallback: T): T {
  const raw = p[key];
  return typeof raw === typeof fallback && raw !== '' ? (raw as T) : fallback;
}

export function bookSettings(p: IndicatorParams): BookHeatmapSettings {
  const source: string = value<string>(p, 'source', 'all');
  return {
    venues: new Set<OrderFlowVenue>(
      source === 'binance' ? ['binance'] : source === 'bybit' ? ['bybit'] : ['binance', 'bybit'],
    ),
    intensity: Math.min(1, Math.max(0.1, value(p, 'intensity', 70) / 100)),
    floor: Math.min(0.9, Math.max(0, value(p, 'floor', 10) / 100)),
    ladder: value(p, 'ladder', true),
    walls: value(p, 'walls', true),
    wallFactor: Math.max(1.05, value(p, 'wallFactor', 1.8)),
    wallMinutes: Math.max(1, value(p, 'wallMinutes', 10)),
    wallMinUsd: Math.max(0, value(p, 'wallMinUsd', 0)),
    wallLimit: Math.max(1, value(p, 'wallLimit', 10)),
    ladderWidth: Math.min(0.4, Math.max(0.03, value(p, 'ladderWidth', 12) / 100)),
    colors: { bid: value(p, 'bidColor', '#1FBF8F'), ask: value(p, 'askColor', '#F0506E') },
  };
}
